exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-btn[data-v-0e262a2a] {\n  margin-right: 16px;\n}\n.action-button[data-v-0e262a2a] {\n  display: inline-block;\n}\n.status-column[data-v-0e262a2a] {\n  width: 100px;\n}\n.service-code-column[data-v-0e262a2a] {\n  width: 100px;\n}\n.quantity-column[data-v-0e262a2a] {\n  width: 100px;\n}\n.actions-column[data-v-0e262a2a] {\n  width: 100px;\n}\n.custom-badge.service-status[data-v-0e262a2a] {\n  max-width: 100%;\n}\n", ""]);

// exports
